/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from 'styled-components';
import Grid from '../../../atoms/Grid';
import Label from '../../../atoms/Label';

const FormGrid = styled(Grid.Container)`
  padding-top: 8px;

  ${Label} {
    margin-bottom: 0;
  }
`;

const UserAttributes = ({
  userAttributesSchema,
  userAttributes,
}: {
  userAttributesSchema: Record<string, any>;
  userAttributes: Record<string, any>;
}) => {
  return (
    <FormGrid>
      {(userAttributesSchema.property_order || Object.keys(userAttributesSchema.properties)).map(
        (key) => {
          const descriptor = userAttributesSchema.properties[key];

          const value = () => {
            switch (descriptor.type) {
              case 'boolean':
                return userAttributes[key] ? 'はい' : 'いいえ';
              default:
                return userAttributes[key];
            }
          };

          return (
            <>
              <Grid.Item size={2}>
                <Label>{descriptor.field_label}</Label>
              </Grid.Item>
              <Grid.Item size={4}>
                <Label>{value()}</Label>
              </Grid.Item>
              <Grid.Divider />
            </>
          );
        }
      )}
    </FormGrid>
  );
};

export default UserAttributes;
